import Button from "../ui/Button";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="container hero__inner">
        <h1 className="hero__title">
          Mastery.
          <br />
          One problem at a time.
        </h1>

        <div className="hero__cta">
          <Button to="/login" variant="primary" size="lg">
            Start learning free
          </Button>
          <a href="#how-it-works" className="hero__scroll">
            See how it works ↓
          </a>
        </div>
      </div>
    </section>
  );
}
